/*
 * @Author: Tahiti
 * @Date: 2025-09-25 15:00:00
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-11-12 11:08:35
 * @Description: Billing page internationalization
 * @FilePath: /weryai-web/locales/modules/billing.ts
 */
export default {
    zh: {
        billing: {
            cancelSubscription: '订阅取消-不会续订',
            title: '订阅详情',
            subtitle: '在此管理您的订阅',
            cancel: '订阅取消-不会续订',
            cancelSubscriptionDescription:
                '此订阅将在当前计费周期结束时终止。在此之前您仍可使用高级功能。',

            status: {
                canceled: '已取消',
                canceledActive: '已取消 - 活跃至周期结束',
            },

            fields: {
                plan: '套餐',
                price: '价格',
                billingPeriod: '计费周期',
                renewalType: '续费类型',
                startDate: '开始日期',
                subscriptionEnd: '订阅结束',
            },

            renewal: {
                automatic: '自动续费',
            },

            cancellation: {
                title: '订阅已取消 - 不会续费',
                description:
                    '此订阅将在当前计费周期结束时终止。在此之前您仍可使用高级功能。',
            },

            actions: {
                contactSupport: '联系客服',
                reactivate: '重新激活',
                cancel: '取消订阅',
                cancelLoading: '正在取消…',
                cancelSuccess: '订阅已成功取消',
            },

            historyHeader: {
                title: '历史记录',
                subtitle: '查看你的订单与任务记录',
            },

            orderHistory: {
                title: '订单历史',
                subtitle: '查看您的历史订单',
                table: {
                    transactionId: '交易号',
                    product: '支付方式',
                    amount: '金额',
                    status: '状态',
                    date: '日期',
                },
                statusMap: {
                    CREATED: '待支付',
                    PAYED: '已支付',
                    REFUNDED: '已退款',
                },
                empty: '暂无订单记录',
                loading: '正在加载订单…',
                pagination: {
                    total: '共 {total} 条记录',
                    perPage: '{size} 条 / 页',
                    items: '条/页',
                },
            },
            taskHistory: {
                title: '任务历史',
                loading: '加载中...',
                empty: '暂无记录',
                table: {
                    time: '时间',
                    type: '类型',
                    amount: '费用（积分）',
                },
                rollback: '积分回滚',
                returned: '已返回',
                pagination: {
                    total: '共 {total} 条记录',
                    perPage: '{size} 条 / 页',
                },
                error: '加载积分记录失败',
            },
        },
    },
    en: {
        billing: {
            title: 'Subscription Details',
            subtitle: 'Manage your subscription here',
            cancelSubscription: 'Subscription Canceled - Will Not Renew',
            cancelSubscriptionDescription:
                'This subscription will end at the current billing period. You can still use premium features until then.',

            status: {
                canceled: 'Canceled',
                canceledActive: 'Canceled - Active Until Period End',
            },

            fields: {
                plan: 'Plan',
                price: 'Price',
                billingPeriod: 'Billing Period',
                renewalType: 'Renewal Type',
                startDate: 'Start Date',
                subscriptionEnd: 'Subscription End',
            },

            renewal: {
                automatic: 'Charge _automatically',
            },

            cancellation: {
                title: 'Subscription Canceled - Will Not Renew',
                description:
                    'This subscription will end at the current billing period. You can still use premium features until then.',
            },

            actions: {
                contactSupport: 'Contact support',
                reactivate: 'Reactivate',
                cancel: 'Cancel Subscription',
                cancelLoading: 'Canceling…',
                cancelSuccess: 'Subscription canceled successfully',
            },

            historyHeader: {
                title: 'History',
                subtitle: 'View your order and task history',
            },

            orderHistory: {
                title: 'Order History',
                subtitle: 'View your order history',
                table: {
                    transactionId: 'Transaction ID',
                    product: 'Payment Method',
                    amount: 'Amount',
                    status: 'Status',
                    date: 'Date',
                },
                statusMap: {
                    CREATED: 'Pending',
                    PAYED: 'Paid',
                    REFUNDED: 'Refunded',
                },
                empty: 'No orders yet',
                loading: 'Loading orders…',
                pagination: {
                    total: '{total} orders in total',
                    perPage: '{size} items / page',
                    items: 'items/page',
                },
            },
            taskHistory: {
                title: 'Task History',
                loading: 'Loading...',
                empty: 'No records',
                table: {
                    time: 'Time',
                    type: 'Type',
                    amount: 'Cost (Points)',
                },
                rollback: 'Points Rollback',
                returned: 'Returned',
                pagination: {
                    total: '{total} records in total',
                    perPage: '{size} items / page',
                },
                error: 'Failed to load task history',
            },
        },
    },
    es: {
        billing: {
            cancelSubscriptionDescription: 'Esta suscripción finalizará al final del período de facturación actual. Aún puede usar las funciones premium hasta entonces.',
            cancelSubscription: 'Suscripción cancelada: no se renovará',
            title: 'Detalles de Suscripción',
            subtitle: 'Gestiona tu suscripción aquí',

            status: {
                canceled: 'Cancelado',
                canceledActive: 'Cancelado - Activo Hasta el Final del Período',
            },

            fields: {
                plan: 'Plan',
                price: 'Precio',
                billingPeriod: 'Período de Facturación',
                renewalType: 'Tipo de Renovación',
                startDate: 'Fecha de Inicio',
                subscriptionEnd: 'Fin de Suscripción',
            },

            renewal: {
                automatic: 'Cobrar automáticamente',
            },

            cancellation: {
                title: 'Suscripción Cancelada - No Se Renovará',
                description:
                    'Esta suscripción terminará en el período de facturación actual. Aún puedes usar las funciones premium hasta entonces.',
            },

            actions: {
                contactSupport: 'contactar soporte',
                reactivate: 'Reactivar',
                cancel: 'Cancelar Suscripción',
                cancelLoading: 'Cancelando…',
                cancelSuccess: 'Suscripción cancelada exitosamente',
            },

            historyHeader: {
                title: 'Historial',
                subtitle: 'Consulta el historial de tus pedidos y tareas',
            },

            orderHistory: {
                title: 'Historial de Pedidos',
                subtitle: 'Ver tu historial de pedidos',
                table: {
                    transactionId: 'ID de Transacción',
                    product: 'Método de Pago',
                    amount: 'Cantidad',
                    status: 'Estado',
                    date: 'Fecha',
                },
                statusMap: {
                    CREATED: 'Pendiente',
                    PAYED: 'Pagado',
                    REFUNDED: 'Reembolsado',
                },
                empty: 'Aún no hay pedidos',
                loading: 'Cargando pedidos…',
                pagination: {
                    total: '{total} pedidos en total',
                    perPage: '{size} elementos / página',
                    items: 'elementos/página',
                },
            },
            taskHistory: {
                title: 'Historial de tareas',
                loading: 'Cargando...',
                empty: 'Sin registros',
                table: {
                    time: 'Tiempo',
                    type: 'Tipo',
                    amount: 'Costo (Puntos)',
                },
                rollback: 'Reembolso de puntos',
                returned: 'Devuelto',
                pagination: {
                    total: '{total} registros en total',
                    perPage: '{size} elementos / página',
                },
                error: 'Error al cargar el historial de puntos',
            },
        },
    },
    de: {
        billing: {
            cancelSubscriptionDescription: 'Dieses Abonnement endet am Ende des aktuellen Abrechnungszeitraums. Bis dahin können Sie weiterhin Premium-Funktionen nutzen.',
            cancelSubscription: 'Abonnement gekündigt – wird nicht verlängert',
            title: 'Abonnement-Details',
            subtitle: 'Verwalten Sie hier Ihr Abonnement',

            status: {
                canceled: 'Storniert',
                canceledActive: 'Storniert - Aktiv Bis Periodenende',
            },

            fields: {
                plan: 'Plan',
                price: 'Preis',
                billingPeriod: 'Abrechnungszeitraum',
                renewalType: 'Verlängerungstyp',
                startDate: 'Startdatum',
                subscriptionEnd: 'Abonnement Ende',
            },

            renewal: {
                automatic: 'Automatisch belasten',
            },

            cancellation: {
                title: 'Abonnement Storniert - Wird Nicht Verlängert',
                description:
                    'Dieses Abonnement endet am Ende des aktuellen Abrechnungszeitraums. Sie können bis dahin weiterhin Premium-Funktionen nutzen.',
            },

            actions: {
                contactSupport: 'Support kontaktieren',
                reactivate: 'Reaktivieren',
                cancel: 'Abonnement Kündigen',
                cancelLoading: 'Kündigen…',
                cancelSuccess: 'Abonnement erfolgreich gekündigt',
            },

            historyHeader: {
                title: 'Verlauf',
                subtitle: 'Sehen Sie sich Ihren Bestell- und Aufgabenverlauf an',
            },

            orderHistory: {
                title: 'Bestellhistorie',
                subtitle: 'Ihre Bestellhistorie anzeigen',
                table: {
                    transactionId: 'Transaktions-ID',
                    product: 'Zahlungsmethode',
                    amount: 'Betrag',
                    status: 'Status',
                    date: 'Datum',
                },
                statusMap: {
                    CREATED: 'Ausstehend',
                    PAYED: 'Bezahlt',
                    REFUNDED: 'Erstattet',
                },
                empty: 'Noch keine Bestellungen',
                loading: 'Bestellungen laden…',
                pagination: {
                    total: '{total} Bestellungen insgesamt',
                    perPage: '{size} Elemente / Seite',
                    items: 'Elemente/Seite',
                },
            },
            taskHistory: {
                title: 'Aufgabenverlauf',
                loading: 'Laden...',
                empty: 'Keine Datensätze',
                table: {
                    time: 'Zeit',
                    type: 'Typ',
                    amount: 'Kosten (Punkte)',
                },
                rollback: 'Punkte-Rückrollung',
                returned: 'Zurückgegeben',
                pagination: {
                    total: 'Insgesamt {total} Datensätze',
                    perPage: '{size} Elemente / Seite',
                },
                error: 'Fehler beim Laden des Punkteverlaufs',
            },
        },
    },
    fr: {
        billing: {
            cancelSubscriptionDescription: 'Cet abonnement se terminera à la fin de la période de facturation en cours. Vous pouvez toujours utiliser les fonctionnalités premium d\'ici là.',
            cancelSubscription: 'Abonnement annulé - ne sera pas renouvelé',
            title: "Détails de l'Abonnement",
            subtitle: 'Gérez votre abonnement ici',

            status: {
                canceled: 'Annulé',
                canceledActive: "Annulé - Actif Jusqu'à la Fin de la Période",
            },

            fields: {
                plan: 'Plan',
                price: 'Prix',
                billingPeriod: 'Période de Facturation',
                renewalType: 'Type de Renouvellement',
                startDate: 'Date de Début',
                subscriptionEnd: "Fin d'Abonnement",
            },

            renewal: {
                automatic: 'Facturer automatiquement',
            },

            cancellation: {
                title: 'Abonnement Annulé - Ne Sera Pas Renouvelé',
                description:
                    "Cet abonnement se terminera à la fin de la période de facturation actuelle. Vous pouvez toujours utiliser les fonctionnalités premium jusqu'à cette date.",
            },

            actions: {
                contactSupport: 'contacter le support',
                reactivate: 'Réactiver',
                cancel: "Annuler l'Abonnement",
                cancelLoading: 'Annulation…',
                cancelSuccess: 'Abonnement annulé avec succès',
            },

            historyHeader: {
                title: 'Historique',
                subtitle: 'Consultez l\'historique de vos commandes et tâches',
            },

            orderHistory: {
                title: 'Historique des Commandes',
                subtitle: 'Voir votre historique de commandes',
                table: {
                    transactionId: 'ID de Transaction',
                    product: 'Méthode de Paiement',
                    amount: 'Montant',
                    status: 'Statut',
                    date: 'Date',
                },
                statusMap: {
                    CREATED: 'En Attente',
                    PAYED: 'Payé',
                    REFUNDED: 'Remboursé',
                },
                empty: 'Aucune commande pour le moment',
                loading: 'Chargement des commandes…',
                pagination: {
                    total: '{total} commandes au total',
                    perPage: '{size} éléments / page',
                    items: 'éléments/page',
                },
            },
            taskHistory: {
                title: 'Historique des tâches',
                loading: 'Chargement...',
                empty: 'Aucun enregistrement',
                table: {
                    time: 'Temps',
                    type: 'Type',
                    amount: 'Coût (Points)',
                },
                rollback: 'Remboursement de points',
                returned: 'Retourné',
                pagination: {
                    total: '{total} enregistrements au total',
                    perPage: '{size} éléments / page',
                },
                error: "Échec du chargement de l'historique des points",
            },
        },
    },
    ja: {
        billing: {
            cancelSubscriptionDescription: 'このサブスクリプションは現在の請求期間の終了時に終了します。それまではプレミアム機能を引き続き使用できます。',
            cancelSubscription: 'サブスクリプションがキャンセルされました - 更新されません',
            title: 'サブスクリプション詳細',
            subtitle: 'ここでサブスクリプションを管理',

            status: {
                canceled: 'キャンセル済み',
                canceledActive: 'キャンセル済み - 期間終了まで有効',
            },

            fields: {
                plan: 'プラン',
                price: '価格',
                billingPeriod: '請求期間',
                renewalType: '更新タイプ',
                startDate: '開始日',
                subscriptionEnd: 'サブスクリプション終了',
            },

            renewal: {
                automatic: '自動請求',
            },

            cancellation: {
                title: 'サブスクリプションキャンセル済み - 更新されません',
                description:
                    'このサブスクリプションは現在の請求期間終了時に終了します。それまではプレミアム機能をご利用いただけます。',
            },

            actions: {
                contactSupport: 'サポートに連絡',
                reactivate: '再アクティベート',
                cancel: 'サブスクリプションキャンセル',
                cancelLoading: 'キャンセル中…',
                cancelSuccess: 'サブスクリプションが正常にキャンセルされました',
            },

            historyHeader: {
                title: '履歴',
                subtitle: '注文とタスクの履歴を表示',
            },

            orderHistory: {
                title: '注文履歴',
                subtitle: '注文履歴を表示',
                table: {
                    transactionId: '取引ID',
                    product: '支払い方法',
                    amount: '金額',
                    status: 'ステータス',
                    date: '日付',
                },
                statusMap: {
                    CREATED: '保留中',
                    PAYED: '支払い済み',
                    REFUNDED: '返金済み',
                },
                empty: '注文がありません',
                loading: '注文を読み込み中…',
                pagination: {
                    total: '合計 {total} 件の注文',
                    perPage: '{size} 件 / ページ',
                    items: '件/ページ',
                },
            },
            taskHistory: {
                title: 'タスク履歴',
                loading: '読み込み中...',
                empty: '記録がありません',
                table: {
                    time: '时间',
                    type: 'タイプ',
                    amount: '费用（ポイント）',
                },
                rollback: 'ポイントの払い戻し',
                returned: '返却済み',
                pagination: {
                    total: '合計 {total} 件の記録',
                    perPage: '{size} 件 / ページ',
                },
                error: 'ポイント履歴の読み込みに失敗しました',
            },
        },
    },
    ko: {
        billing: {
            cancelSubscriptionDescription: '이 구독은 현재 결제 기간이 끝나면 종료됩니다. 그 전까지는 프리미엄 기능을 계속 사용할 수 있습니다.',
            cancelSubscription: '구독이 취소됨 - 갱신되지 않음',
            title: '구독 세부사항',
            subtitle: '여기서 구독을 관리하세요',

            status: {
                canceled: '취소됨',
                canceledActive: '취소됨 - 기간 종료까지 활성',
            },

            fields: {
                plan: '플랜',
                price: '가격',
                billingPeriod: '결제 기간',
                renewalType: '갱신 유형',
                startDate: '시작일',
                subscriptionEnd: '구독 종료',
            },

            renewal: {
                automatic: '자동 결제',
            },

            cancellation: {
                title: '구독 취소됨 - 갱신되지 않음',
                description:
                    '이 구독은 현재 결제 기간 종료 시 종료됩니다. 그때까지 프리미엄 기능을 계속 사용할 수 있습니다.',
            },

            actions: {
                contactSupport: '고객지원 문의',
                reactivate: '재활성화',
                cancel: '구독 취소',
                cancelLoading: '취소 중…',
                cancelSuccess: '구독이 성공적으로 취소되었습니다',
            },

            historyHeader: {
                title: '기록',
                subtitle: '주문 및 작업 기록을 확인하세요',
            },

            orderHistory: {
                title: '주문 내역',
                subtitle: '주문 내역 보기',
                table: {
                    transactionId: '거래 ID',
                    product: '결제 방법',
                    amount: '금액',
                    status: '상태',
                    date: '날짜',
                },
                statusMap: {
                    CREATED: '대기 중',
                    PAYED: '결제됨',
                    REFUNDED: '환불됨',
                },
                empty: '아직 주문이 없습니다',
                loading: '주문 로딩 중…',
                pagination: {
                    total: '총 {total}개 주문',
                    perPage: '{size}개 / 페이지',
                    items: '개/페이지',
                },
            },
            taskHistory: {
                title: '작업 기록',
                loading: '로딩 중...',
                empty: '기록이 없습니다',
                table: {
                    time: '시간',
                    type: '유형',
                    amount: '비용 (포인트)',
                },
                rollback: '포인트 롤백',
                returned: '반환됨',
                pagination: {
                    total: '총 {total}개 기록',
                    perPage: '{size}개 / 페이지',
                },
                error: '포인트 내역을 불러오지 못했습니다',
            },
        },
    },
    tw: {
        billing: {
            cancelSubscription: '訂閱取消-不會續訂',
            title: '訂閱詳情',
            subtitle: '在此管理您的訂閱',
            cancel: '訂閱已取消－不再續訂',
            cancelSubscriptionDescription:
                '此訂閱將在當前計費週期結束時終止。在此之前您仍可使用進階功能。',

            status: {
                canceled: '已取消',
                canceledActive: '已取消－有效至週期結束',
            },

            fields: {
                plan: '方案',
                price: '價格',
                billingPeriod: '計費週期',
                renewalType: '續訂類型',
                startDate: '開始日期',
                subscriptionEnd: '訂閱結束',
            },

            renewal: {
                automatic: '自動續訂',
            },

            cancellation: {
                title: '訂閱已取消－不再續訂',
                description:
                    '此訂閱將在當前計費週期結束時終止。在此之前您仍可使用進階功能。',
            },

            actions: {
                contactSupport: '聯絡客服',
                reactivate: '重新啟用',
                cancel: '取消訂閱',
                cancelLoading: '取消中…',
                cancelSuccess: '訂閱已成功取消',
            },

            historyHeader: {
                title: '歷史記錄',
                subtitle: '查看你的訂單與任務記錄',
            },

            orderHistory: {
                title: '訂單紀錄',
                subtitle: '查看歷史訂單',
                table: {
                    transactionId: '交易號',
                    product: '支付方式',
                    amount: '金額',
                    status: '狀態',
                    date: '日期',
                },
                statusMap: {
                    CREATED: '待付款',
                    PAYED: '已付款',
                    REFUNDED: '已退款',
                },
                empty: '暫無訂單紀錄',
                loading: '載入訂單中…',
                pagination: {
                    total: '共 {total} 筆',
                    perPage: '{size} 筆/頁',
                    items: '筆/頁',
                },
            },
            taskHistory: {
                title: '任務歷史',
                loading: '載入中...',
                empty: '暫無記錄',
                table: {
                    time: '時間',
                    type: '類型',
                    amount: '費用（積分）',
                },
                rollback: '積分回滾',
                returned: '已返回',
                pagination: {
                    total: '共 {total} 條記錄',
                    perPage: '{size} 條 / 頁',
                },
                error: '載入積分紀錄失敗',
            },
        },
    },
    pl: {
        billing: {
            title: 'Szczegóły subskrypcji',
            subtitle: 'Zarządzaj subskrypcją tutaj',
            cancelSubscription: 'Subskrypcja anulowana — nie odnowi się',
            cancelSubscriptionDescription:
                'Subskrypcja zakończy się z końcem bieżącego okresu rozliczeniowego. Do tego czasu możesz korzystać z funkcji premium.',

            status: {
                canceled: 'Anulowana',
                canceledActive: 'Anulowana — aktywna do końca okresu',
            },

            fields: {
                plan: 'Plan',
                price: 'Cena',
                billingPeriod: 'Okres rozliczeniowy',
                renewalType: 'Typ odnowienia',
                startDate: 'Data rozpoczęcia',
                subscriptionEnd: 'Koniec subskrypcji',
            },

            renewal: {
                automatic: 'Pobieraj opłatę automatycznie',
            },

            cancellation: {
                title: 'Subskrypcja anulowana — nie odnowi się',
                description:
                    'Subskrypcja zakończy się z końcem bieżącego okresu rozliczeniowego. Do tego czasu możesz korzystać z funkcji premium.',
            },

            actions: {
                contactSupport: 'Skontaktuj się z pomocą',
                reactivate: 'Aktywuj ponownie',
                cancel: 'Anuluj subskrypcję',
                cancelLoading: 'Anulowanie…',
                cancelSuccess: 'Subskrypcja została anulowana',
            },

            historyHeader: {
                title: 'Historia',
                subtitle: 'Zobacz historię swoich zamówień i zadań',
            },

            orderHistory: {
                title: 'Historia zamówień',
                subtitle: 'Zobacz historię zamówień',
                table: {
                    transactionId: 'ID transakcji',
                    product: 'Metoda płatności',
                    amount: 'Kwota',
                    status: 'Status',
                    date: 'Data',
                },
                statusMap: {
                    CREATED: 'Oczekuje na płatność',
                    PAYED: 'Opłacone',
                    REFUNDED: 'Zwrócone',
                },
                empty: 'Brak zamówień',
                loading: 'Ładowanie zamówień…',
                pagination: {
                    total: 'Łącznie {total} zamówień',
                    perPage: '{size} / strona',
                    items: 'pozycji/strona',
                },
            },
            taskHistory: {
                title: 'Historia zadań',
                loading: 'Ładowanie...',
                empty: 'Brak rekordów',
                table: {
                    time: 'Czas',
                    type: 'Typ',
                    amount: 'Koszt (punkty)',
                },
                rollback: 'Wycofanie punktów',
                returned: 'Zwrócono',
                pagination: {
                    total: 'Łącznie {total} rekordów',
                    perPage: '{size} elementów / strona',
                },
                error: 'Nie udało się załadować historii punktów',
            },
        },
    },
    pt: {
        billing: {
            cancelSubscriptionDescription: 'Esta assinatura terminará no final do período de faturamento atual. Você ainda pode usar os recursos premium até lá.',
            cancelSubscription: 'Assinatura cancelada - não será renovada',
            title: 'Detalhes da Assinatura',
            subtitle: 'Gerencie sua assinatura aqui',

            status: {
                canceled: 'Cancelado',
                canceledActive: 'Cancelado - Ativo Até o Fim do Período',
            },

            fields: {
                plan: 'Plano',
                price: 'Preço',
                billingPeriod: 'Período de Cobrança',
                renewalType: 'Tipo de Renovação',
                startDate: 'Data de Início',
                subscriptionEnd: 'Fim da Assinatura',
            },

            renewal: {
                automatic: 'Cobrar automaticamente',
            },

            cancellation: {
                title: 'Assinatura Cancelada - Não Será Renovada',
                description:
                    'Esta assinatura terminará no período de cobrança atual. Você ainda pode usar os recursos premium até então.',
            },

            actions: {
                contactSupport: 'entrar em contato com o suporte',
                reactivate: 'Reativar',
                cancel: 'Cancelar Assinatura',
                cancelLoading: 'Cancelando…',
                cancelSuccess: 'Assinatura cancelada com sucesso',
            },

            historyHeader: {
                title: 'Histórico',
                subtitle: 'Veja o histórico dos seus pedidos e tarefas',
            },

            orderHistory: {
                title: 'Histórico de Pedidos',
                subtitle: 'Ver seu histórico de pedidos',
                table: {
                    transactionId: 'ID da Transação',
                    product: 'Método de Pagamento',
                    amount: 'Valor',
                    status: 'Status',
                    date: 'Data',
                },
                statusMap: {
                    CREATED: 'Pendente',
                    PAYED: 'Pago',
                    REFUNDED: 'Reembolsado',
                },
                empty: 'Nenhum pedido ainda',
                loading: 'Carregando pedidos…',
                pagination: {
                    total: '{total} pedidos no total',
                    perPage: '{size} itens / página',
                    items: 'itens/página',
                },
            },
            taskHistory: {
                title: 'Histórico de tarefas',
                loading: 'Carregando...',
                empty: 'Sem registros',
                table: {
                    time: 'Tempo',
                    type: 'Tipo',
                    amount: 'Custo (Pontos)',
                },
                rollback: 'Estorno de pontos',
                returned: 'Devolvido',
                pagination: {
                    total: '{total} registros no total',
                    perPage: '{size} itens / página',
                },
                error: 'Falha ao carregar o histórico de pontos',
            },
        },
    },
    th: {
        billing: {
            cancelSubscriptionDescription: 'การสมัครสมาชิกนี้จะสิ้นสุดเมื่อสิ้นสุดรอบการชำระเงินปัจจุบัน คุณยังสามารถใช้ฟีเจอร์พรีเมียมได้จนกว่าจะถึงตอนนั้น',
            cancelSubscription: 'ยกเลิกการสมัครสมาชิกแล้ว - จะไม่ต่ออายุ',
            title: 'รายละเอียดการสมัครสมาชิก',
            subtitle: 'จัดการการสมัครสมาชิกของคุณที่นี่',

            status: {
                canceled: 'ยกเลิกแล้ว',
                canceledActive: 'ยกเลิกแล้ว - ใช้งานได้จนถึงสิ้นสุดระยะเวลา',
            },

            fields: {
                plan: 'แผน',
                price: 'ราคา',
                billingPeriod: 'ระยะเวลาการเรียกเก็บเงิน',
                renewalType: 'ประเภทการต่ออายุ',
                startDate: 'วันที่เริ่มต้น',
                subscriptionEnd: 'สิ้นสุดการสมัครสมาชิก',
            },

            renewal: {
                automatic: 'เรียกเก็บเงินอัตโนมัติ',
            },

            cancellation: {
                title: 'ยกเลิกการสมัครสมาชิกแล้ว - จะไม่ต่ออายุ',
                description:
                    'การสมัครสมาชิกนี้จะสิ้นสุดในระยะเวลาการเรียกเก็บเงินปัจจุบัน คุณยังสามารถใช้ฟีเจอร์พรีเมียมได้จนถึงเวลานั้น',
            },

            actions: {
                contactSupport: 'ติดต่อฝ่ายสนับสนุน',
                reactivate: 'เปิดใช้งานใหม่',
                cancel: 'ยกเลิกการสมัครสมาชิก',
                cancelLoading: 'กำลังยกเลิก…',
                cancelSuccess: 'ยกเลิกการสมัครสมาชิกสำเร็จ',
            },

            historyHeader: {
                title: 'ประวัติ',
                subtitle: 'ดูประวัติคำสั่งซื้อและงานของคุณ',
            },

            orderHistory: {
                title: 'ประวัติการสั่งซื้อ',
                subtitle: 'ดูประวัติการสั่งซื้อของคุณ',
                table: {
                    transactionId: 'รหัสธุรกรรม',
                    product: 'วิธีการชำระเงิน',
                    amount: 'จำนวนเงิน',
                    status: 'สถานะ',
                    date: 'วันที่',
                },
                statusMap: {
                    CREATED: 'รอดำเนินการ',
                    PAYED: 'ชำระแล้ว',
                    REFUNDED: 'คืนเงินแล้ว',
                },
                empty: 'ยังไม่มีคำสั่งซื้อ',
                loading: 'กำลังโหลดคำสั่งซื้อ…',
                pagination: {
                    total: '{total} คำสั่งซื้อทั้งหมด',
                    perPage: '{size} รายการ / หน้า',
                    items: 'รายการ/หน้า',
                },
            },
            taskHistory: {
                title: 'ประวัติงาน',
                loading: 'กำลังโหลด...',
                empty: 'ไม่มีบันทึก',
                table: {
                    time: 'เวลา',
                    type: 'ประเภท',
                    amount: 'ค่าใช้จ่าย (คะแนน)',
                },
                rollback: 'การย้อนกลับคะแนน',
                returned: 'คืนแล้ว',
                pagination: {
                    total: 'รวม {total} รายการ',
                    perPage: '{size} รายการ / หน้า',
                },
                error: 'โหลดประวัติคะแนนไม่สำเร็จ',
            },
        },
    },
    vi: {
        billing: {
            title: 'Chi Tiết Đăng Ký',
            subtitle: 'Quản lý đăng ký của bạn tại đây',

            status: {
                canceled: 'Đã Hủy',
                canceledActive: 'Đã Hủy - Hoạt Động Đến Cuối Kỳ',
            },

            fields: {
                plan: 'Gói',
                price: 'Giá',
                billingPeriod: 'Chu Kỳ Thanh Toán',
                renewalType: 'Loại Gia Hạn',
                startDate: 'Ngày Bắt Đầu',
                subscriptionEnd: 'Kết Thúc Đăng Ký',
            },

            renewal: {
                automatic: 'Tự động thanh toán',
            },

            cancellation: {
                title: 'Đăng Ký Đã Hủy - Sẽ Không Gia Hạn',
                description:
                    'Đăng ký này sẽ kết thúc vào cuối chu kỳ thanh toán hiện tại. Bạn vẫn có thể sử dụng các tính năng cao cấp cho đến lúc đó.',
            },

            actions: {
                contactSupport: 'liên hệ hỗ trợ',
                reactivate: 'Kích Hoạt Lại',
                cancel: 'Hủy Đăng Ký',
                cancelLoading: 'Đang hủy…',
                cancelSuccess: 'Hủy đăng ký thành công',
            },

            historyHeader: {
                title: 'Lịch sử',
                subtitle: 'Xem lịch sử đơn hàng và tác vụ của bạn',
            },

            orderHistory: {
                title: 'Lịch Sử Đơn Hàng',
                subtitle: 'Xem lịch sử đơn hàng của bạn',
                table: {
                    transactionId: 'ID Giao Dịch',
                    product: 'Phương Thức Thanh Toán',
                    amount: 'Số Tiền',
                    status: 'Trạng Thái',
                    date: 'Ngày',
                },
                statusMap: {
                    CREATED: 'Chờ Xử Lý',
                    PAYED: 'Đã Thanh Toán',
                    REFUNDED: 'Đã Hoàn Tiền',
                },
                empty: 'Chưa có đơn hàng nào',
                loading: 'Đang tải đơn hàng…',
                pagination: {
                    total: 'Tổng cộng {total} đơn hàng',
                    perPage: '{size} mục / trang',
                    items: 'mục/trang',
                },
            },
            taskHistory: {
                loading: 'Đang tải...',
                empty: 'Chưa có đơn hàng nào',
                table: {
                    time: 'Thời gian',
                    type: 'Loại',
                    amount: 'Chi phí (Điểm)',
                },
                rollback: 'Hoàn điểm',
                returned: 'Đã hoàn',
                pagination: {
                    total: 'Tổng cộng {total} bản ghi',
                    perPage: '{size} mục / trang',
                },
                error: 'Tải lịch sử điểm thất bại',
            },
        },
    },
    ru: {
        billing: {
            title: 'Детали подписки',
            subtitle: 'Управляйте своей подпиской здесь',
            cancelSubscription: 'Подписка отменена - не будет продлена',
            cancelSubscriptionDescription:
                'Эта подписка закончится в конце текущего расчетного периода. Вы по-прежнему можете использовать премиум-функции до этого времени.',

            status: {
                canceled: 'Отменено',
                canceledActive: 'Отменено - Активно до конца периода',
            },

            fields: {
                plan: 'План',
                price: 'Цена',
                billingPeriod: 'Расчетный период',
                renewalType: 'Тип продления',
                startDate: 'Дата начала',
                subscriptionEnd: 'Окончание подписки',
            },

            renewal: {
                automatic: 'Автоматическое списание',
            },

            cancellation: {
                title: 'Подписка отменена - не будет продлена',
                description:
                    'Эта подписка закончится в конце текущего расчетного периода. Вы по-прежнему можете использовать премиум-функции до этого времени.',
            },

            actions: {
                contactSupport: 'связаться с поддержкой',
                reactivate: 'Реактивировать',
                cancel: 'Отменить подписку',
                cancelLoading: 'Отмена…',
                cancelSuccess: 'Подписка успешно отменена',
            },

            historyHeader: {
                title: 'История',
                subtitle: 'Просмотрите историю ваших заказов и задач',
            },

            orderHistory: {
                title: 'История заказов',
                subtitle: 'Просмотр истории ваших заказов',
                table: {
                    transactionId: 'ID транзакции',
                    product: 'Способ оплаты',
                    amount: 'Сумма',
                    status: 'Статус',
                    date: 'Дата',
                },
                statusMap: {
                    CREATED: 'Ожидается',
                    PAYED: 'Оплачено',
                    REFUNDED: 'Возвращено',
                },
                empty: 'Заказов пока нет',
                loading: 'Загрузка заказов…',
                pagination: {
                    total: 'Всего {total} заказов',
                    perPage: '{size} элементов / страница',
                    items: 'элементов/страница',
                },
            },
            taskHistory: {
                title: 'История задач',
                loading: 'Загрузка...',
                empty: 'Нет записей',
                table: {
                    time: 'Время',
                    type: 'Тип',
                    amount: 'Стоимость (баллы)',
                },
                rollback: 'Откат баллов',
                returned: 'Возвращено',
                pagination: {
                    total: 'Всего {total} записей',
                    perPage: '{size} элементов / страница',
                },
                error: 'Не удалось загрузить историю баллов',
            },
        },
    },
    it: {
        billing: {
            title: "Dettagli dell'Abbonamento",
            subtitle: 'Gestisci il tuo abbonamento qui',
            cancelSubscription: 'Abbonamento Annullato - Non Verrà Rinnovato',
            cancelSubscriptionDescription:
                'Questo abbonamento terminerà al periodo di fatturazione corrente. Puoi ancora utilizzare le funzionalità premium fino ad allora.',

            status: {
                canceled: 'Annullato',
                canceledActive: 'Annullato - Attivo Fino alla Fine del Periodo',
            },

            fields: {
                plan: 'Piano',
                price: 'Prezzo',
                billingPeriod: 'Periodo di Fatturazione',
                renewalType: 'Tipo di Rinnovo',
                startDate: 'Data di Inizio',
                subscriptionEnd: "Fine dell'Abbonamento",
            },

            renewal: {
                automatic: 'Addebito automatico',
            },

            cancellation: {
                title: 'Abbonamento Annullato - Non Verrà Rinnovato',
                description:
                    'Questo abbonamento terminerà al periodo di fatturazione corrente. Puoi ancora utilizzare le funzionalità premium fino ad allora.',
            },

            actions: {
                contactSupport: 'contatta il supporto',
                reactivate: 'Riattiva',
                cancel: 'Annulla Abbonamento',
                cancelLoading: 'Annullamento…',
                cancelSuccess: 'Abbonamento annullato con successo',
            },

            historyHeader: {
                title: 'Cronologia',
                subtitle: 'Visualizza la cronologia dei tuoi ordini e delle tue attività',
            },

            orderHistory: {
                title: 'Cronologia Ordini',
                subtitle: 'Visualizza la cronologia dei tuoi ordini',
                table: {
                    transactionId: 'ID Transazione',
                    product: 'Metodo di Pagamento',
                    amount: 'Importo',
                    status: 'Stato',
                    date: 'Data',
                },
                statusMap: {
                    CREATED: 'In Attesa',
                    PAYED: 'Pagato',
                    REFUNDED: 'Rimborsato',
                },
                empty: 'Nessun ordine ancora',
                loading: 'Caricamento ordini…',
                pagination: {
                    total: '{total} ordini in totale',
                    perPage: '{size} elementi / pagina',
                    items: 'elementi/pagina',
                },
            },
            taskHistory: {
                title: 'Cronologia attività',
                loading: 'Caricamento...',
                empty: 'Nessun record',
                table: {
                    time: 'Tempo',
                    type: 'Tipo',
                    amount: 'Costo (Punti)',
                },
                rollback: 'Storno punti',
                returned: 'Restituito',
                pagination: {
                    total: '{total} record in totale',
                    perPage: '{size} elementi / pagina',
                },
                error: "Errore nel caricamento della cronologia punti",
            },
        },
    },
    ar: {
        billing: {
            title: 'تفاصيل الاشتراك',
            subtitle: 'إدارة اشتراكك هنا',
            cancelSubscription: 'تم إلغاء الاشتراك - لن يتم التجديد',
            cancelSubscriptionDescription:
                'سينتهي هذا الاشتراك في نهاية فترة الفوترة الحالية. لا يزال بإمكانك استخدام الميزات المميزة حتى ذلك الحين.',

            status: {
                canceled: 'ملغي',
                canceledActive: 'ملغي - نشط حتى نهاية الفترة',
            },

            fields: {
                plan: 'الخطة',
                price: 'السعر',
                billingPeriod: 'فترة الفوترة',
                renewalType: 'نوع التجديد',
                startDate: 'تاريخ البدء',
                subscriptionEnd: 'نهاية الاشتراك',
            },

            renewal: {
                automatic: 'الخصم التلقائي',
            },

            cancellation: {
                title: 'تم إلغاء الاشتراك - لن يتم التجديد',
                description:
                    'سينتهي هذا الاشتراك في نهاية فترة الفوترة الحالية. لا يزال بإمكانك استخدام الميزات المميزة حتى ذلك الحين.',
            },

            actions: {
                contactSupport: 'اتصل بالدعم',
                reactivate: 'إعادة التفعيل',
                cancel: 'إلغاء الاشتراك',
                cancelLoading: 'جارٍ الإلغاء…',
                cancelSuccess: 'تم إلغاء الاشتراك بنجاح',
            },

            historyHeader: {
                title: 'السجل',
                subtitle: 'عرض سجل طلباتك ومهامك',
            },

            orderHistory: {
                title: 'سجل الطلبات',
                subtitle: 'عرض سجل طلباتك',
                table: {
                    transactionId: 'معرف المعاملة',
                    product: 'طريقة الدفع',
                    amount: 'المبلغ',
                    status: 'الحالة',
                    date: 'التاريخ',
                },
                statusMap: {
                    CREATED: 'قيد الانتظار',
                    PAYED: 'مدفوع',
                    REFUNDED: 'مسترد',
                },
                empty: 'لا توجد طلبات بعد',
                loading: 'جارٍ تحميل الطلبات…',
                pagination: {
                    total: '{total} طلب في المجموع',
                    perPage: '{size} عنصر / صفحة',
                    items: 'عنصر/صفحة',
                },
            },
            taskHistory: {
                title: 'سجل المهام',
                loading: 'جارٍ التحميل...',
                empty: 'لا توجد سجلات',
                table: {
                    time: 'الوقت',
                    type: 'النوع',
                    amount: 'التكلفة (نقاط)',
                },
                rollback: 'استرداد النقاط',
                returned: 'تم الإرجاع',
                pagination: {
                    total: 'إجمالي {total} سجلات',
                    perPage: '{size} عنصر / صفحة',
                },
                error: 'فشل تحميل سجل النقاط',
            },
        },
    },
    da: {
        billing: {
            title: 'Abonnementsdetaljer',
            subtitle: 'Administrer dit abonnement her',
            cancelSubscription: 'Abonnement annulleret - Vil ikke blive fornyet',
            cancelSubscriptionDescription:
                'Dette abonnement slutter ved den aktuelle faktureringsperiode. Du kan stadig bruge premium-funktioner indtil da.',

            status: {
                canceled: 'Annulleret',
                canceledActive: 'Annulleret - Aktiv indtil periodens udløb',
            },

            fields: {
                plan: 'Plan',
                price: 'Pris',
                billingPeriod: 'Faktureringsperiode',
                renewalType: 'Fornyelsestype',
                startDate: 'Startdato',
                subscriptionEnd: 'Abonnement slutter',
            },

            renewal: {
                automatic: 'Opkræv automatisk',
            },

            cancellation: {
                title: 'Abonnement annulleret - Vil ikke blive fornyet',
                description:
                    'Dette abonnement slutter ved den aktuelle faktureringsperiode. Du kan stadig bruge premium-funktioner indtil da.',
            },

            actions: {
                contactSupport: 'Kontakt support',
                reactivate: 'Genaktiver',
                cancel: 'Annuller abonnement',
                cancelLoading: 'Annullerer…',
                cancelSuccess: 'Abonnement annulleret med succes',
            },

            historyHeader: {
                title: 'Historik',
                subtitle: 'Se historikken for dine ordrer og opgaver',
            },

            orderHistory: {
                title: 'Ordrehistorik',
                subtitle: 'Se din ordrehistorik',
                table: {
                    transactionId: 'Transaktions-ID',
                    product: 'Betalingsmetode',
                    amount: 'Beløb',
                    status: 'Status',
                    date: 'Dato',
                },
                statusMap: {
                    CREATED: 'Afventer',
                    PAYED: 'Betalt',
                    REFUNDED: 'Refunderet',
                },
                empty: 'Ingen ordrer endnu',
                loading: 'Indlæser ordrer…',
                pagination: {
                    total: '{total} ordrer i alt',
                    perPage: '{size} elementer / side',
                    items: 'elementer/side',
                },
            },
            taskHistory: {
                title: 'Opgavehistorik',
                loading: 'Indlæser...',
                empty: 'Ingen poster',
                table: {
                    time: 'Tid',
                    type: 'Type',
                    amount: 'Pris (Point)',
                },
                rollback: 'Point-tilbagerulning',
                returned: 'Returneret',
                pagination: {
                    total: '{total} poster i alt',
                    perPage: '{size} elementer / side',
                },
                error: 'Kunne ikke indlæse point-historik',
            },
        },
    },
    no: {
        billing: {
            title: 'Abonnementsdetaljer',
            subtitle: 'Administrer abonnementet ditt her',
            cancelSubscription: 'Abonnement kansellert - Vil ikke bli fornyet',
            cancelSubscriptionDescription:
                'Dette abonnementet avsluttes ved slutten av gjeldende faktureringsperiode. Du kan fortsatt bruke premium-funksjoner frem til da.',

            status: {
                canceled: 'Kansellert',
                canceledActive: 'Kansellert - Aktiv til periodens slutt',
            },

            fields: {
                plan: 'Plan',
                price: 'Pris',
                billingPeriod: 'Faktureringsperiode',
                renewalType: 'Fornyelsestype',
                startDate: 'Startdato',
                subscriptionEnd: 'Abonnement slutter',
            },

            renewal: {
                automatic: 'Belast automatisk',
            },

            cancellation: {
                title: 'Abonnement kansellert - Vil ikke bli fornyet',
                description:
                    'Dette abonnementet avsluttes ved slutten av gjeldende faktureringsperiode. Du kan fortsatt bruke premium-funksjoner frem til da.',
            },

            actions: {
                contactSupport: 'Kontakt support',
                reactivate: 'Reaktiver',
                cancel: 'Kanseller abonnement',
                cancelLoading: 'Kansellerer…',
                cancelSuccess: 'Abonnement kansellert',
            },

            historyHeader: {
                title: 'Historikk',
                subtitle: 'Se historikken for dine bestillinger og oppgaver',
            },

            orderHistory: {
                title: 'Ordrehistorikk',
                subtitle: 'Se ordrehistorikken din',
                table: {
                    transactionId: 'Transaksjons-ID',
                    product: 'Betalingsmetode',
                    amount: 'Beløb',
                    status: 'Status',
                    date: 'Dato',
                },
                statusMap: {
                    CREATED: 'Venter',
                    PAYED: 'Betalt',
                    REFUNDED: 'Refundert',
                },
                empty: 'Ingen ordrer ennå',
                loading: 'Laster ordrer…',
                pagination: {
                    total: '共 {total} 筆',
                    perPage: '{size} 筆/頁',
                    items: '筆/頁',
                },
            },
            taskHistory: {
                title: 'Oppgavehistorikk',
                loading: 'Laster...',
                empty: 'Ingen poster',
                table: {
                    time: 'Tid',
                    type: 'Type',
                    amount: 'Kostnad (Poeng)',
                },
                rollback: 'Poeng-tilbakerulling',
                returned: 'Returnert',
                pagination: {
                    total: '{total} poster totalt',
                    perPage: '{size} elementer / side',
                },
                error: 'Kunne ikke laste poeng-historikk',
            },
        },
    },
    nl: {
        billing: {
            title: 'Abonnementsdetails',
            subtitle: 'Beheer hier uw abonnement',
            cancelSubscription: 'Abonnement geannuleerd - Wordt niet verlengd',
            cancelSubscriptionDescription:
                'Dit abonnement eindigt aan het einde của de huidige factureringsperiode. U kunt tot die tijd nog steeds premium-functies gebruiken.',

            status: {
                canceled: 'Geannuleerd',
                canceledActive: 'Geannuleerd - Actief tot einde periode',
            },

            fields: {
                plan: 'Plan',
                price: 'Prijs',
                billingPeriod: 'Factureringsperiode',
                renewalType: 'Verlengingstype',
                startDate: 'Startdatum',
                subscriptionEnd: 'Abonnement eindigt',
            },

            renewal: {
                automatic: 'Automatisch afschrijven',
            },

            cancellation: {
                title: 'Abonnement geannuleerd - Wordt niet verlengd',
                description:
                    'Dit abonnement eindigt aan het einde van de huidige factureringsperiode. U kunt tot die tijd nog steeds premium-functies gebruiken.',
            },

            actions: {
                contactSupport: 'Contact opnemen mit support',
                reactivate: 'Heractiveren',
                cancel: 'Abonnement opzeggen',
                cancelLoading: 'Annuleren…',
                cancelSuccess: 'Abonnement succesvol geannuleerd',
            },

            historyHeader: {
                title: 'Geschiedenis',
                subtitle: 'Bekijk je bestel- en taakgeschiedenis',
            },

            orderHistory: {
                title: 'Bestelgeschiedenis',
                subtitle: 'Bekijk uw bestelgeschiedenis',
                table: {
                    transactionId: 'Transactie-ID',
                    product: 'Betaalmethode',
                    amount: 'Bedrag',
                    status: 'Status',
                    date: 'Datum',
                },
                statusMap: {
                    CREATED: 'In afwachting',
                    PAYED: 'Betaald',
                    REFUNDED: 'Terugbetaald',
                },
                empty: 'Nog geen bestellingen',
                loading: 'Bestellingen laden…',
                pagination: {
                    total: '{total} bestellingen in totaal',
                    perPage: '{size} items / pagina',
                    items: 'items/pagina',
                },
            },
            taskHistory: {
                title: 'Taakgeschiedenis',
                loading: 'Laden...',
                empty: 'Geen records',
                table: {
                    time: 'Tijd',
                    type: 'Type',
                    amount: 'Kosten (Punten)',
                },
                rollback: 'Punten terugdraaien',
                returned: 'Geretourneerd',
                pagination: {
                    total: '{total} records in totaal',
                    perPage: '{size} items / pagina',
                },
                error: 'Laden van puntenhistorie mislukt',
            },
        },
    },
    id: {
        billing: {
            title: 'Detail Langganan',
            subtitle: 'Kelola langganan Anda di sini',
            cancelSubscription: 'Langganan Dibatalkan - Tidak Akan Diperpanjang',
            cancelSubscriptionDescription:
                'Langganan ini akan berakhir pada periode penagihan saat ini. Anda masih dapat menggunakan fitur premium sampai saat itu.',

            status: {
                canceled: 'Dibatalkan',
                canceledActive: 'Dibatalkan - Aktif Hingga Akhir Periode',
            },

            fields: {
                plan: 'Paket',
                price: 'Harga',
                billingPeriod: 'Periode Penagihan',
                renewalType: 'Jenis Perpanjangan',
                startDate: 'Tanggal Mulai',
                subscriptionEnd: 'Langganan Berakhir',
            },

            renewal: {
                automatic: 'Tagih secara otomatis',
            },

            cancellation: {
                title: 'Langganan Dibatalkan - Tidak Akan Diperpanjang',
                description:
                    'Langganan ini akan berakhir pada periode penagihan saat ini. Anda masih dapat menggunakan fitur premium sampai saat itu.',
            },

            actions: {
                contactSupport: 'Hubungi dukungan',
                reactivate: 'Aktifkan kembali',
                cancel: 'Batalkan Langganan',
                cancelLoading: 'Membatalkan…',
                cancelSuccess: 'Langganan berhasil dibatalkan',
            },

            historyHeader: {
                title: 'Riwayat',
                subtitle: 'Lihat riwayat pesanan dan tugas Anda',
            },

            orderHistory: {
                title: 'Riwayat Pesanan',
                subtitle: 'Lihat riwayat pesanan Anda',
                table: {
                    transactionId: 'ID Transaksi',
                    product: 'Metode Pembayaran',
                    amount: 'Jumlah',
                    status: 'Status',
                    date: 'Tanggal',
                },
                statusMap: {
                    CREATED: 'Menunggu',
                    PAYED: 'Dibayar',
                    REFUNDED: 'Dikembalikan',
                },
                empty: 'Belum ada pesanan',
                loading: 'Memuat pesanan…',
                pagination: {
                    total: '{total} pesanan total',
                    perPage: '{size} item / halaman',
                    items: 'item/halaman',
                },
            },
            taskHistory: {
                title: 'Riwayat tugas',
                loading: 'Memuat...',
                empty: 'Tidak ada catatan',
                table: {
                    time: 'Waktu',
                    type: 'Tipe',
                    amount: 'Biaya (Poin)',
                },
                rollback: 'Rollback Poin',
                returned: 'Dikembalikan',
                pagination: {
                    total: 'Total {total} catatan',
                    perPage: '{size} item / halaman',
                },
                error: 'Gagal memuat riwayat poin',
            },
        },
    },
    tr: {
        billing: {
            title: 'Abonelik Detayları',
            subtitle: 'Aboneliğinizi buradan yönetin',
            cancelSubscription: 'Abonelik İptal Edildi - Yenilenmeyecek',
            cancelSubscriptionDescription:
                'Bu abonelik mevcut fatura döneminin sonunda sona erecektir. O zamana kadar premium özellikleri kullanmaya devam edebilirsiniz.',

            status: {
                canceled: 'İptal Edildi',
                canceledActive: 'İptal Edildi - Dönem Sonuna Kadar Aktif',
            },

            fields: {
                plan: 'Plan',
                price: 'Fiyat',
                billingPeriod: 'Fatura Dönemi',
                renewalType: 'Yenileme Türü',
                startDate: 'Başlangıç Tarihi',
                subscriptionEnd: 'Abonelik Sonu',
            },

            renewal: {
                automatic: 'Otomatik ücretlendir',
            },

            cancellation: {
                title: 'Abonelik İptal Edildi - Yenilenmeyecek',
                description:
                    'Bu abonelik mevcut fatura döneminin sonunda sona erecektir. O zamana kadar premium özellikleri kullanmaya devam edebilirsiniz.',
            },

            actions: {
                contactSupport: 'Destek ile iletişime geçin',
                reactivate: 'Yeniden Etkinleştir',
                cancel: 'Aboneliği İptal Et',
                cancelLoading: 'İptal ediliyor…',
                cancelSuccess: 'Abonelik başarıyla iptal edildi',
            },

            historyHeader: {
                title: 'Geçmiş',
                subtitle: 'Sipariş ve görev geçmişinizi görüntüleyin',
            },

            orderHistory: {
                title: 'Sipariş Geçmişi',
                subtitle: 'Sipariş geçmişinizi görüntüleyin',
                table: {
                    transactionId: 'İşlem Kimliği',
                    product: 'Ödeme Yöntemi',
                    amount: 'Tutar',
                    status: 'Durum',
                    date: 'Tarih',
                },
                statusMap: {
                    CREATED: 'Beklemede',
                    PAYED: 'Ödendi',
                    REFUNDED: 'İade Edildi',
                },
                empty: 'Henüz sipariş yok',
                loading: 'Siparişler yükleniyor…',
                pagination: {
                    total: 'Toplam {total} sipariş',
                    perPage: '{size} öğe / sayfa',
                    items: 'öğe/sayfa',
                },
            },
            taskHistory: {
                title: 'Görev geçmişi',
                loading: 'Yükleniyor...',
                empty: 'Kayıt yok',
                table: {
                    time: 'Zaman',
                    type: 'Tür',
                    amount: 'Maliyet (Puan)',
                },
                rollback: 'Puan Geri Alma',
                returned: 'İade edildi',
                pagination: {
                    total: 'Toplam {total} kayıt',
                    perPage: '{size} öğe / sayfa',
                },
                error: 'Puan geçmişi yüklenemedi',
            },
        },
    },
};
